document.addEventListener('DOMContentLoaded',function(){
    var COLLAPSED_MAX_HEIGHT = 105;

    function getExpandTarget(btn) {
        var prose = btn.parentElement && btn.parentElement.querySelector('.product__description .prose, .prose');
        if (prose) return prose;
        var section = btn.previousElementSibling;
        if (section && section.classList.contains('product_title_features')) return section;
        return btn.parentElement ? btn.parentElement.querySelector('.prose') : null;
    }

    function initKeyFeaturesExpandButtons() {
        document.querySelectorAll('.key-features-expand-btn').forEach(function(btn) {
            var target = getExpandTarget(btn);
            if (!target) {
                btn.hidden = true;
                return;
            }

            var text = (target.textContent || '').replace(/\u00a0/g, ' ').trim();
            if (!text || target.scrollHeight <= COLLAPSED_MAX_HEIGHT) {
                btn.hidden = true;
                target.classList.add('product_features_show');
            }
        });
    }

    document.querySelectorAll('.key-features-expand-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
            var isOpen = btn.getAttribute('data-open') === 'true';
            var target = getExpandTarget(btn);
            if (!target) return;

            if (!isOpen) {
                btn.setAttribute('data-open', 'true');
                btn.classList.add('isOpenBtn');
                target.classList.add('product_features_show');
            } else {
                btn.setAttribute('data-open', 'false');
                btn.classList.remove('isOpenBtn');
                target.classList.remove('product_features_show');
            }
        });
    });

    initKeyFeaturesExpandButtons();

    function scrollProductTabsNav(tabItem) {
        var tabsNav = tabItem.closest('ul.tabs')
        if (!tabsNav || window.innerWidth > 749) return

        var maxScroll = tabsNav.scrollWidth - tabsNav.clientWidth
        if (maxScroll <= 0) return

        var peek = 80
        var navWidth = tabsNav.clientWidth
        var btnLeft = tabItem.offsetLeft
        var btnWidth = tabItem.offsetWidth
        var targetScroll = btnLeft - (navWidth - btnWidth) / 2
        var hiddenRight = maxScroll - targetScroll
        var hiddenLeft = targetScroll

        if (hiddenRight > peek) {
            targetScroll = Math.min(maxScroll, btnLeft + btnWidth - navWidth + peek)
        } else if (hiddenLeft > peek) {
            targetScroll = Math.max(0, btnLeft - peek)
        }

        tabsNav.scrollTo({
            left: Math.max(0, Math.min(maxScroll, targetScroll)),
            behavior: 'smooth'
        })
    }

    function initProductTabsNavHint() {
        if (window.innerWidth > 749) return
        document.querySelectorAll('.product-tabs-body ul.tabs').forEach(function(tabsNav) {
            var activeTab = tabsNav.querySelector('li.active') || tabsNav.querySelector('li')
            if (activeTab) scrollProductTabsNav(activeTab)
        })
    }

    function normalizeProductTabLabels() {
        document.querySelectorAll('.product-tabs-body-item ul.tabs li').forEach(function(tab) {
            var target = tab.querySelector('a') || tab
            var label = target.textContent.trim()
            if (/^specifications?$/i.test(label)) {
                target.textContent = 'Specification'
            } else if (/^faqs?$/i.test(label)) {
                target.textContent = 'FAQS'
            }
        })
    }

    normalizeProductTabLabels()

    // specification-tabs（描述内联 script 会被 Shopify 过滤；EVO III 用 evo3-* 且无 data-tab）
    var SPEC_TAB_SELECTOR = '.specification-tab-btn, .evo3-specification-tab-btn'
    var SPEC_PANEL_SELECTOR = '.specification-panel, .evo3-specification-panel'
    var SPEC_SECTION_SELECTOR = '.specification-section, .evo3-specification-section, .specification-container, .evo3-specification-container'

    function activateSpecificationTab(tab) {
        var section = tab.closest(SPEC_SECTION_SELECTOR) || tab.parentElement
        if (!section) return

        var buttons = section.querySelectorAll(SPEC_TAB_SELECTOR)
        var panels = section.querySelectorAll(SPEC_PANEL_SELECTOR)

        buttons.forEach(function(btn) {
            btn.classList.remove('active')
        })
        panels.forEach(function(panel) {
            panel.classList.remove('active')
        })
        tab.classList.add('active')

        var targetId = tab.getAttribute('data-tab')
        var targetPanel = null
        if (targetId) {
            targetPanel = section.querySelector('#' + targetId) || document.getElementById(targetId)
        }
        if (!targetPanel) {
            var index = Array.prototype.indexOf.call(buttons, tab)
            if (index > -1) targetPanel = panels[index]
        }
        if (targetPanel) targetPanel.classList.add('active')
    }

    if (!window.__specTabsDelegated) {
        window.__specTabsDelegated = true
        document.addEventListener('click', function(event) {
            var tab = event.target.closest(SPEC_TAB_SELECTOR)
            if (!tab) return
            event.preventDefault()
            activateSpecificationTab(tab)
        })
    }

    // product tab 切换（描述内 ul.tabs）
    $(".product-tabs-body ul.tabs li").click(function(){
        let index = $(this).index()+1
        $(this).addClass("active").siblings().removeClass("active")
        $(`.product-tabs-body ul.tabs-content li:nth-child(${index})`).addClass("active").siblings().removeClass("active")

        scrollProductTabsNav(this)

        var $bodyItem = $(this).closest('.product-tabs-body-item')
        if ($bodyItem.length) {
            $('html,body').animate({scrollTop: $bodyItem.offset().top}, 800)
        }
    })

    initProductTabsNavHint()
    window.addEventListener('resize', initProductTabsNavHint)

    // 外层 product-tabs-header 切换
    $(".product-tabs-header-item").click(function(){
        var target = $(this).attr('data-tab')
        var $tabs = $(this).closest('.product-tabs')
        $(this).addClass('active').siblings().removeClass('active')
        $tabs.find('#' + target).addClass('active').siblings('.product-tabs-body-item').removeClass('active')
    })

    // 4T / Max 系列 Overview：nav-item-liteenterprise 摄像头切换（来自 autelpilot-live）
    function showLiteenterpriseContent(index) {
        var contents = document.querySelectorAll('.content-liteenterprise')
        if (!contents.length) return

        contents.forEach(function(content) {
            content.classList.remove('active-liteenterprise')
        })
        if (typeof index === 'number' && contents[index]) {
            contents[index].classList.add('active-liteenterprise')
        }

        document.querySelectorAll('.nav-item-liteenterprise').forEach(function(button, idx) {
            button.classList.toggle('active-liteenterprise', idx === index)
        })
    }

    function initLiteenterpriseTabs() {
        var buttons = document.querySelectorAll('.nav-item-liteenterprise')
        if (!buttons.length) return

        buttons.forEach(function(button, index) {
            if (button.dataset.liteenterpriseBound === 'true') return
            button.dataset.liteenterpriseBound = 'true'
            button.addEventListener('click', function() {
                showLiteenterpriseContent(index)
            })
        })

        showLiteenterpriseContent(0)
    }

    initLiteenterpriseTabs()

    // FAQ
    $('.FAQsRight .Section span').click(function() {
        $(".FAQsRight .Section span").removeClass('iconTransform')
        $(this).parent().find('.panel-content').slideToggle(function(){
            if($(this).parent().find('.panel-content').is(':visible')){
                $(this).parent().find('span').addClass('iconTransform')
                $(this).parent().siblings().find('.panel-content').slideUp()
                $(this).parents(".panel").siblings().find('.panel-content').slideUp()
            }else{
                $(this).parent().find('span').removeClass('iconTransform')
            }
        });
    })
    $('.FAQsRight .Section span').each(function() {
        $(this).next('.panel-content').hide()
    })
    $('.FAQsLeft ul li').click(function() {
        let faqIndex = $(this).index() + 1
        $('html,body').animate({
            scrollTop: $('.FAQsRight .panel:nth-child(' + faqIndex + ')').offset().top - 1
        }, 800);
    });
})


function initProductAccessoryBundle() {
    function formatMoney(cents) {
        const formatString = window.shopMoneyFormat || '$';
        const value = (cents / 100.0).toFixed(2);
        const formattedValue = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        const formatted = formatString.replace(/\{\{\s*\w+\s*\}\}/g, formattedValue);
        return formatted.replace(/<[^>]*>/g, '').trim();
    }

    const container = document.querySelector('.accessory-items');
    if (!container || container.dataset.bundleBound === 'true') return;
    container.dataset.bundleBound = 'true';

    // 2. 配件整块区域的点击逻辑（capture 阶段先更新，避免其它监听器读到旧状态）
    container.addEventListener('click', function(e) {
        const item = e.target.closest('.accessory-item');
        if (!item || item.classList.contains('disabled')) return;

        const checkbox = item.querySelector('.accessory-checkbox');
        const qtyInput = item.querySelector('.accessory-qty');
        
        // --- A. 如果点到的是数量加减按钮 ---
        const qtyBtn = e.target.closest('.qty-btn');
        if (qtyBtn) {
            e.preventDefault();
            e.stopPropagation();
            let currentVal = parseInt(qtyInput.value, 10) || 1;
            if (qtyBtn.classList.contains('plus')) {
                qtyInput.value = currentVal + 1;
            } else if (qtyBtn.classList.contains('minus') && currentVal > 1) {
                qtyInput.value = currentVal - 1;
            }
            if (!checkbox.checked) {
                checkbox.checked = true;
                item.classList.add('is-selected');
            }
            updateBundleTotal();
            return;
        }

        // --- B. 如果点到的是数量输入框本身 ---
        if (e.target.closest('.accessory-quantity')) {
            e.stopPropagation();
            return; 
        }

        // --- C. 如果点击的是整行其他区域 ---
        if (e.target !== checkbox) {
            e.preventDefault();
            checkbox.checked = !checkbox.checked;
        }

        // 统一更新状态
        item.classList.toggle('is-selected', checkbox.checked);
        updateBundleTotal();
    }, true);

    container.addEventListener('change', (e) => {
        if (e.target.matches('.accessory-checkbox')) {
            updateBundleTotal();
        }
    });


    // 3. 总价计算核心逻辑
    function getMainQuantity() {
        const qtyInput =
            document.querySelector('.product-form__quantity .quantity__input') ||
            document.querySelector('form[action*="/cart/add"] [name="quantity"]');
        const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        return Number.isFinite(qty) && qty > 0 ? qty : 1;
    }

    function getCurrentVariant() {
        const product = window.ShopifyProduct;
        const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (!product || !Array.isArray(product.variants) || product.variants.length === 0) return null;

        const variantId = variantInput ? parseInt(variantInput.value, 10) : NaN;
        if (Number.isFinite(variantId)) {
            return product.variants.find((variant) => Number(variant.id) === variantId) || null;
        }

        return product.variants.find((variant) => variant.available) || product.variants[0] || null;
    }

    function getBfDiscountCents(mainQty) {
        const discount = Number(window.bfDiscount || 0);
        if (!Number.isFinite(discount) || discount <= 0) return 0;
        const qty = Number.isFinite(mainQty) && mainQty > 0 ? mainQty : 1;
        return Math.round(discount * 100) * qty;
    }

    function updateBundleTotal() {
        const variant = getCurrentVariant();
        const mainQty = getMainQuantity();
        const basePriceCents = variant ? Number(variant.price) || 0 : 0;
        const compareAtCents =
            variant && Number(variant.compare_at_price) > basePriceCents
                ? Number(variant.compare_at_price)
                : basePriceCents;

        let totalCents = basePriceCents * mainQty;
        let totalCompareCents = compareAtCents * mainQty;

        container.querySelectorAll('.accessory-item').forEach((row) => {
            const checkbox = row.querySelector('.accessory-checkbox');
            const qtyInput = row.querySelector('.accessory-qty');

            if (checkbox && checkbox.checked) {
                const price = parseInt(checkbox.dataset.price, 10) || 0;
                const qty = parseInt(qtyInput?.value, 10) || 1;
                totalCents += price * qty;
                totalCompareCents += price * qty;
            }
        });

        const discountCents = getBfDiscountCents(mainQty);
        const displayCents = Math.max(0, totalCents - discountCents);
        let bundleCompareCents = 0;
        if (discountCents > 0) {
            bundleCompareCents = totalCents;
        } else if (totalCompareCents > totalCents) {
            bundleCompareCents = totalCompareCents;
        }

        document.querySelectorAll('.bundle-current_price').forEach((el) => {
            el.textContent = formatMoney(displayCents);
        });

        document.querySelectorAll('.bundle-original_price').forEach((el) => {
            if (bundleCompareCents > displayCents) {
                el.textContent = formatMoney(bundleCompareCents);
                el.style.removeProperty('display');
            } else {
                el.style.display = 'none';
            }
        });

        document.querySelectorAll('.buyMe .price__current .money').forEach((el) => {
            el.textContent = formatMoney(displayCents);
        });
        document.querySelectorAll('.buyMe .price__current .original_price').forEach((el) => {
            el.textContent = bundleCompareCents > displayCents ? formatMoney(bundleCompareCents) : '';
        });

        // 折扣卡片的逻辑
        const salePriceEl = document.querySelector('[data-sale-price]');
        if (salePriceEl && variant) {
            const discountCents = getBfDiscountCents(1);
            const saleCents = Math.max(0, basePriceCents - discountCents);
            salePriceEl.textContent = formatMoney(saleCents);
        }

        document.dispatchEvent(
            new CustomEvent('product:bundle-price-updated', {
                detail: { displayCents, compareCents: bundleCompareCents }
            })
        );
    }

    window.updateProductBundlePrice = updateBundleTotal;

    const mainQtyInput =
        document.querySelector('.product-form__quantity .quantity__input') ||
        document.querySelector('form[action*="/cart/add"] [name="quantity"]');
    if (mainQtyInput) {
        mainQtyInput.addEventListener('change', updateBundleTotal);
        mainQtyInput.addEventListener('input', updateBundleTotal);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        updateBundleTotal();
      });
    }

    updateBundleTotal();

    // 5. 购买/加购逻辑
    const addToCartBtn = document.querySelector('.bundle-add-to-cart-btn');
    const buyButtonsArea = document.querySelector('.product-form-buyBtns');

    function getBundleItems() {
        let itemsToAdd = [];
        const mainVariantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
        const qtyElement = document.querySelector('form[action*="/cart/add"] [name="quantity"]') || document.querySelector('.quantity__input'); 
        
        if (mainVariantInput && mainVariantInput.value) {
            itemsToAdd.push({ id: parseInt(mainVariantInput.value), quantity: qtyElement ? parseInt(qtyElement.value) : 1 });
        }

        container.querySelectorAll('.accessory-checkbox:checked').forEach(checkbox => {
            const variantId = checkbox.dataset.variantId;
            const qtyInput = checkbox.closest('.accessory-item').querySelector('.accessory-qty');
            if (variantId) {
                itemsToAdd.push({ id: parseInt(variantId), quantity: parseInt(qtyInput.value) || 1 });
            }
        });
        return itemsToAdd;
    }

    async function handleBundleSubmit(e, actionType) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation?.();

        const itemsToAdd = getBundleItems();
        if (itemsToAdd.length === 0) return;

        try {
            const rootUrl = window.Shopify?.routes?.root || '/';

            if (actionType === 'buy_now') {
                await fetch(`${rootUrl}cart/clear.js`, { method: 'POST' });
            }

            const addRes = await fetch(`${rootUrl}cart/add.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify(itemsToAdd.length === 1 ? itemsToAdd[0] : { items: itemsToAdd })
            });

            if (!addRes.ok) {
                let message = 'Add to cart failed';
                try {
                    const data = await addRes.json();
                    message = data.description || data.message || message;
                } catch {}
                throw new Error(message);
            }

            if (actionType === 'buy_now') {
                window.location.href = `${rootUrl}checkout`;
            } else {
                window.location.href = `${rootUrl}cart`;
            }
        } catch (error) {
            console.error('Action failed:', error);
        }
    }

    if (addToCartBtn) addToCartBtn.addEventListener('click', (e) => handleBundleSubmit(e, 'add_to_cart'));

    if (buyButtonsArea) {
        buyButtonsArea.addEventListener('click', (e) => {
            const paymentTrigger = e.target.closest(
                '.shopify-payment-button, shopify-paypal-button, shopify-accelerated-checkout-cart, .shopify-payment-button__button, .shopify-payment-button__more-options'
            );
            if (!paymentTrigger) return;
            handleBundleSubmit(e, 'buy_now');
        }, true);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductAccessoryBundle);
} else {
    initProductAccessoryBundle();
}
// EVO III 4T Pro 多设备 //

(function () {

  const section =
    document.getElementById(
      'evo3-agc'
    );


  if (!section) return;



  const slides =
    Array.from(
      section.querySelectorAll(
        '.evo3-agc-slide'
      )
    );



  const tabs =
    Array.from(
      section.querySelectorAll(
        '.evo3-agc__tab'
      )
    );



  const viewport =
    section.querySelector(
      '.evo3-agc__viewport'
    );



  const prevButton =
    section.querySelector(
      '.evo3-agc__arrow--prev'
    );



  const nextButton =
    section.querySelector(
      '.evo3-agc__arrow--next'
    );



  if (!slides.length) return;



  let currentIndex = 0;



  /* =====================================================
     SHOW SLIDE
  ===================================================== */

  function showSlide(index) {


    if (index < 0) {

      index =
        slides.length - 1;

    }


    if (
      index >=
      slides.length
    ) {

      index = 0;

    }



    currentIndex =
      index;



    slides.forEach(
      function (
        slide,
        i
      ) {

        const active =
          i ===
          currentIndex;


        slide.classList.toggle(
          'is-active',
          active
        );


        slide.setAttribute(
          'aria-hidden',
          active
            ? 'false'
            : 'true'
        );

      }
    );



    tabs.forEach(
      function (
        tab,
        i
      ) {

        const active =
          i ===
          currentIndex;


        tab.classList.toggle(
          'is-active',
          active
        );


        tab.setAttribute(
          'aria-selected',
          active
            ? 'true'
            : 'false'
        );

      }
    );



    centerMobileTab();

  }



  /* =====================================================
     MOBILE TAB AUTO CENTER
  ===================================================== */

  function centerMobileTab() {


    if (
      window.innerWidth >
      749
    ) {

      return;

    }



    const activeTab =
      tabs[
        currentIndex
      ];



    if (!activeTab) return;



    const parent =
      activeTab.parentElement;



    if (!parent) return;



    const parentWidth =
      parent.clientWidth;


    const tabWidth =
      activeTab.offsetWidth;


    const tabLeft =
      activeTab.offsetLeft;



    const target =
      tabLeft -
      parentWidth / 2 +
      tabWidth / 2;



    parent.scrollTo({

      left:
        target,

      behavior:
        'smooth'

    });

  }



  /* =====================================================
     TAB CLICK
  ===================================================== */

  tabs.forEach(
    function (tab) {


      tab.addEventListener(
        'click',
        function () {


          const index =
            parseInt(
              this.dataset.index,
              10
            );


          if (
            Number.isNaN(
              index
            )
          ) {

            return;

          }


          showSlide(
            index
          );

        }
      );

    }
  );



  /* =====================================================
     ARROWS
  ===================================================== */

  if (prevButton) {

    prevButton.addEventListener(
      'click',
      function () {


        showSlide(
          currentIndex - 1
        );

      }
    );

  }



  if (nextButton) {

    nextButton.addEventListener(
      'click',
      function () {


        showSlide(
          currentIndex + 1
        );

      }
    );

  }



  /* =====================================================
     MOBILE SWIPE
  ===================================================== */

  let touchStartX = 0;

  let touchStartY = 0;

  let touchEndX = 0;

  let touchEndY = 0;



  if (viewport) {


    viewport.addEventListener(
      'touchstart',
      function (event) {


        if (
          !event.changedTouches ||
          !event.changedTouches.length
        ) {

          return;

        }


        touchStartX =
          event
            .changedTouches[0]
            .clientX;


        touchStartY =
          event
            .changedTouches[0]
            .clientY;

      },
      {
        passive: true
      }
    );



    viewport.addEventListener(
      'touchend',
      function (event) {


        if (
          !event.changedTouches ||
          !event.changedTouches.length
        ) {

          return;

        }


        touchEndX =
          event
            .changedTouches[0]
            .clientX;


        touchEndY =
          event
            .changedTouches[0]
            .clientY;


        handleSwipe();

      },
      {
        passive: true
      }
    );

  }



  function handleSwipe() {


    const distanceX =
      touchEndX -
      touchStartX;


    const distanceY =
      touchEndY -
      touchStartY;


    const minimumSwipe =
      45;



    if (
      Math.abs(
        distanceY
      ) >
      Math.abs(
        distanceX
      )
    ) {

      return;

    }



    if (
      Math.abs(
        distanceX
      ) <
      minimumSwipe
    ) {

      return;

    }



    if (
      distanceX < 0
    ) {

      showSlide(
        currentIndex + 1
      );

    }

    else {

      showSlide(
        currentIndex - 1
      );

    }

  }



  /* =====================================================
     KEYBOARD
  ===================================================== */

  section.addEventListener(
    'keydown',
    function (event) {


      if (
        event.key ===
        'ArrowLeft'
      ) {

        showSlide(
          currentIndex - 1
        );

      }



      if (
        event.key ===
        'ArrowRight'
      ) {

        showSlide(
          currentIndex + 1
        );

      }

    }
  );



  /* =====================================================
     RESIZE
  ===================================================== */

  let resizeTimer;



  window.addEventListener(
    'resize',
    function () {


      clearTimeout(
        resizeTimer
      );


      resizeTimer =
        setTimeout(
          function () {

            centerMobileTab();

          },
          100
        );

    }
  );



  /* =====================================================
     INIT
  ===================================================== */

  showSlide(0);

})();